module.exports = "/dist/assets/images/timeline-separator.svg";